import { openDialog } from '@patrianna/dialog-manager'

import type { BaseBonus } from '@patrianna/shared-patrianna-types/store/BonusesFlowModule'

export const openDelayedBonusRewardDialog = (bonus: BaseBonus) => {
  openDialog({ dialogName: 'REWARD_DIALOG', dialogProps: { bonus } })
}
